import {Component, effect, inject, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, GuardsCheckEnd, NavigationStart, Router, RouterOutlet} from '@angular/router';
import {MatDrawer, MatDrawerContainer, MatDrawerContent} from '@angular/material/sidenav';
import {SidebarComponent} from './common/sidebar/sidebar.component';
import {NgIf} from '@angular/common';
import {Auth, authState, User} from '@angular/fire/auth';
import {lastValueFrom, Subscription} from 'rxjs';
import {AuthService} from './services/auth.service';
import {UserService} from './services/user.service';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {jwtDecode} from 'jwt-decode';
import {OrganizationService} from './services/organization.service';
import {MatIcon} from '@angular/material/icon';
import {MatButton} from '@angular/material/button';


@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    MatDrawerContainer,
    MatDrawer,
    MatDrawerContent,
    SidebarComponent,
    NgIf,
    MatProgressSpinner,
    MatIcon,
    MatButton,
  ],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit, OnDestroy{
  title = 'gm-frontend';
  showSidenav = true;

  private auth: Auth = inject(Auth);
  private gmAuthService = inject(AuthService);
  organizationService = inject(OrganizationService);
  authState$ = authState(this.auth);
  authStateSubscription?: Subscription;

  lastAuthState?: User | null;

  userService = inject(UserService);
  loading = true;

  constructor(private router: Router) {
    effect(() => {
      if (this.auth.currentUser) {
        this.loading = this.userService.users().length === 0
      } else {
        this.loading = false;
      }
    });
  }
  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      const hiddenRoutes = ['/login', '/signup', '/assinatura']; // Routes where sidenav is hidden
      this.showSidenav = !hiddenRoutes.includes(this.router.url.split('?')[0]);
    });

    this.authStateSubscription = this.authState$.subscribe(async (aUser: User | null) => {
      if (aUser) {
        const decodedToken = jwtDecode(await aUser.getIdToken());
        this.gmAuthService.postAuth(aUser.uid, decodedToken);
        if (this.lastAuthState === null || this.router.url === '/') {
          // await this.router.navigate(aUser ? ['/calendario'] : ['/login']);
        }
      } else {
        await this.router.navigate(['/login']);
      }
      this.lastAuthState = aUser;
    })
  }

  ngOnDestroy() {
    this.authStateSubscription?.unsubscribe();
  }

}
